import { gql } from "@apollo/client";

export const GET_ULTIMOS_INGRESOS = gql`
  query GetUltimosIngresos {
    ultimosIngresos {
      title
      description
      link
      items {
        id
        title
        link
        guid
        image
        location
        price
        content
        category
        bedrooms
        bathrooms
        area
      }
    }
  }
`;

export interface UltimosIngresosItem {
  id: string;
  title: string;
  link: string;
  guid: string;
  image: string;
  location: string;
  price: string;
  content: string;
  category: string;
  bedrooms: number | null;
  bathrooms: number | null;
  area: number;
}

export interface UltimosIngresosResponse {
  ultimosIngresos: {
    title: string;
    description: string;
    link: string;
    items: UltimosIngresosItem[];
  };
}
